import axios from 'axios';

// Copied from asl-api-ts-v1 types. Didn't want to add the whole asl-api-ts-v1 just for this one type.
type RefreshTokenResponse = {
  /**
   * A bearer token that can be used for future requests.
   */
  token: string;
  /**
   * The expiry time of this token.
   */
  expiry: string;
};

/**
 * Refreshes the authentication token using a direct axios call
 *
 * This function sends a GET request to the refresh token endpoint with credentials
 * (cookies) included. The server validates the refresh token in the cookie and
 * returns a new access token if valid.
 *
 * @param apiUrl - The base API URL
 * @returns Promise with the refreshed token data
 * @throws Will throw an error if the refresh token is invalid or the request fails
 */
export async function refreshToken<T extends RefreshTokenResponse>(
  apiUrl: string,
): Promise<T> {
  const response = await axios.get<T>(`${apiUrl}/apis/dbui/v1/refresh-token`, {
    withCredentials: true,
  });
  return response.data;
}
